import Vue from "vue";
const EventBus = new Vue();
export default EventBus;



// WEBPACK FOOTER //
// ./src/data/eventbus.js